const classNames = (list: (string | undefined | false)[]): string => (
  list.map((item) => {
    if (item) return item
    return null
  }).join(" ")
)

export default classNames
